import { render, staticRenderFns } from "./MessageIndex.vue?vue&type=template&id=04f60b82"
import script from "./MessageIndex.vue?vue&type=script&lang=js"
export * from "./MessageIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports